import { CloseOutlined, SaveOutlined } from "@ant-design/icons";
import { Button, Space } from "antd";
import { useMemo, useRef, useState } from "react";
import MultiPane from "@components/tabs-responsive/tabs-responsive";
import { useViewportBreakpoint } from "../../hooks/useViewportBreakpoint";
import "../company/company.css";
import CompanyItemMain from "./company-item-main";
import CompanyItemUsers from "./company-item-users";

const CompanyItem = ({ companyId, onClose }) => {
  const isMobile = useViewportBreakpoint() === "mobile";
  const [tabKey, setTabKey] = useState("main");
  const [mainSaving, setMainSaving] = useState(false);
  const mainRef = useRef(null);

  const onHeaderSave = () => {
    if (tabKey === "main") mainRef.current?.save();
  };

  const paneItems = useMemo(
    () => [
      {
        key: "main",
        label: "Основные",
        children: (
          <CompanyItemMain
            ref={mainRef}
            companyId={companyId}
            onClose={onClose}
            isMobile={isMobile}
            onSavingChange={setMainSaving}
          />
        ),
      },
      {
        key: "users",
        label: "Пользователи",
        children: <CompanyItemUsers companyId={companyId} />,
      },
    ],
    [companyId, onClose, isMobile]
  );

  if (isMobile) {
    return (
      <div>
        <div
          className="misoft-modal-overlay company-base-overlay--mobile"
          onClick={e => e.target === e.currentTarget && onClose(false)}
        >
          <div className="misoft-modal-content company-base-sheet--mobile" onClick={e => e.stopPropagation()}>
            <div className="company-base-sheet-header">
              <span className="company-base-sheet-title">Компания</span>
              <Space size="small" className="company-base-sheet-actions">
                {tabKey === "main" ? (
                  <Button
                    type="primary"
                    icon={<SaveOutlined />}
                    onClick={onHeaderSave}
                    loading={mainSaving}
                    aria-label="Сохранить"
                    className="company-base-header-icon-btn"
                  />
                ) : null}
                <Button
                  type="default"
                  icon={<CloseOutlined />}
                  onClick={() => onClose(false)}
                  aria-label="Закрыть"
                  className="company-base-header-icon-btn"
                />
              </Space>
            </div>
            <div className="company-base-sheet-body">
              <MultiPane activeKey={tabKey} onChange={setTabKey} items={paneItems} type="card" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="cloud-modal-overlay" onClick={() => onClose(false)} />

      <div className="cloud-modal-license-order-keys">
        <div className="cloud-modal-header">
          <h3>Компания</h3>
          <Button onClick={() => onClose(false)} type="text">
            ×
          </Button>
        </div>

        <div className="cloud-modal-content">
          <MultiPane items={paneItems} type="card" />
        </div>
      </div>
    </>
  );
};

export default CompanyItem;
